/** Snake-case id: `PREFER_IN_PERSON_TUTOR` → `prefer_in_person_tutor`, `I forgot about it` → `i_forgot_about_it`. */
export const toAnalyticsId = (raw: string | number): string =>
  String(raw).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')

/** Visible copy without markup. */
export const plainText = (html: string): string => html.replace(/<[^>]*>/g, '')

/** Picked local slot `YYYY-MM-DD HH:mm:ss` → ISO 8601 local. */
export const isoValue = (slot: string): string => slot.trim().replace(' ', 'T')

/** Backend UTC timestamp (`2026-10-24 19:00:00` or ISO) → ISO 8601 UTC, for `booking_time`. */
export const utcIso = (raw: string | null | undefined): string | null => {
  if (!raw) return null
  const value = raw.trim().replace(' ', 'T')

  return /(Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`
}

/** Contact channel as the registry names it: the backend's `WA` is `whatsapp`. */
export const channelId = (raw: string): string => (raw === 'WA' ? 'whatsapp' : toAnalyticsId(raw))

/** Option id from its label, without a trailing `[...]` follow-up qualifier: `Other (please specify) [How…?]` → `other_please_specify`. */
export const answerId = (label: string): string => toAnalyticsId(label.replace(/\s*\[.*\]\s*$/, ''))

/** A link without its query and hash: lesson links carry access tokens there. */
export const plainUrl = (url: string | null | undefined): string | null => (url ? url.split(/[?#]/)[0]! : null)
